import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "next/image";
export function ShopifyExpertsBadge(t0) {
  const $ = _c(4);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `inline-flex items-center gap-2.5 select-none ${className}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Image src="/images/icons/shopify.png" alt="Shopify" width={32} height={32} className="h-8 w-8 object-contain sm:h-9 sm:w-9" />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex items-baseline gap-1.5 font-poppins"><span className="text-[20px] font-bold tracking-tight text-[#0b1354] sm:text-[23px] dark:text-white">shopify</span><span className="font-sans text-[19px] font-normal italic text-[#66698a] sm:text-[22px] dark:text-gray-300">experts</span></div>;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t2) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  return t5;
}
export function LaravelExpertsBadge(t0) {
  const $ = _c(4);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `inline-flex items-center gap-2.5 select-none ${className}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg className="h-8 w-8 shrink-0 text-[#ff2d20] sm:h-9 sm:w-9" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 4L58 19V49L32 64L6 49V19L32 4Z" stroke="#ff2d20" strokeWidth="3.5" strokeLinejoin="round" /><path d="M32 4V34M58 19L32 34M6 19L32 34M32 34V64" stroke="#ff2d20" strokeWidth="3.5" strokeLinejoin="round" /><path d="M48 6L60 13V27L48 34L36 27V13L48 6Z" stroke="#ff2d20" strokeWidth="2.5" strokeLinejoin="round" className="fill-white dark:fill-[#070b14]" /><path d="M48 6V20M60 13L48 20M36 13L48 20M48 20V34" stroke="#ff2d20" strokeWidth="2.5" strokeLinejoin="round" /></svg>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex items-baseline gap-1.5 font-poppins"><span className="text-[20px] font-bold tracking-tight text-[#ff2d20] sm:text-[23px]">Laravel</span><span className="font-sans text-[19px] font-normal italic text-[#0b1354] sm:text-[22px] dark:text-white">experts</span></div>;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t2) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  return t5;
}